<template>
  <div class="borrow-list" >
    <!-- <div v-if="showTips" class="borrow-tips">
      <img src="./images/icon_tanhao@2x.png" alt="">
      您的{{status === 'credit' ? '授信' : '提现'}}申请暂未通过，为您匹配更优借款通道
    </div> -->
    <div class="borrow-title">
      <div class="title-left">
        {{title}}
        <div v-if="showSub" class="title-tags">
          <div class="tag-item tag-1">3家可下款</div>
          <div class="tag-item tag-2">高通过率</div>
        </div>
      </div>
      <div class="title-right" @click="jumpRiver">
        更多爆款
        <img src="./images/arrow@2x.png" alt="">
      </div>
    </div>
    <template>
      <div class="borrow-content" v-if="lth<6">
        <borrow-item
          v-for="(item, index) in borrowList"
          :key="index"
          :item="item"
          @on-borrow="borrowMoney(item, index)"
        />
      </div>
      <div v-else>
        <van-swipe :loop="false" :width="swipeWidth"  >
          <van-swipe-item :show-indicators="false" v-for="item in borrowList.length" :key="`p${item}`">
            <div class="borrow-content" :style="item===1?{'padding-right':'0.26rem'}:{'padding-left':'0.26rem'}" >
              <borrow-item
                v-for="(i, index) in borrowList[item-1]"
                :key="`${item}-${index}`"
                :item="i"
                @on-borrow="borrowMoney(i, index)"
              />
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </template>
    <div v-if="showSwipe && swipeList && swipeList.length" class="borrow-swipe">
      <van-swipe
        :show-indicators="false"
        class="my-swipe"
        :autoplay="2000"
        :loop="true"
      >
        <van-swipe-item
          v-for="(item, index) in swipeList"
          :key="index"
        >
          <div class="text">{{item}}</div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'
import { mapActions } from 'vuex'

export default {
  name: 'borrow-list',
  props: {
    // 是否展示提示
    showTips: {
      type: Boolean,
      default: false
    },
    // 是否展示小标题
    showSub: {
      type: Boolean,
      default: false
    },
    // 是否展示轮播
    showSwipe: {
      type: Boolean,
      default: false
    },
    source: {
      default: '',
      type: String
    },
    status: {
      default: '',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    type: {
      default: '',
      type: String
    },
    showPlace: {
      default: '',
      type: String
    },
    step: {
      type: String,
      default: ''
    }
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    'borrow-item': () => import('./borrow-item.vue')
  },
  data () {
    return {
      borrowList: [], // 借款列表
      swipeList: [],
      swipeWidth: 100,
      lth: 0,
      showSwipeList: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions('user', ['getBorrowList']),
    ...mapActions(['dataPoint']),
    async init () {
      const response = await this.getBorrowList({ showPlace: this.showPlace || 'HOME', queryBanner: false, version: 'V2' })
      if (response.success) {
        const { scrollBars, configs } = response.data
        this.lth = (configs && configs.length) || 0
        this.swipeWidth = document.body.clientWidth - 150
        if (!this.lth) return
        configs.map(item => {
          this.$report({
            id: 10002,
            args: { position: this.type, target: item.configId, step: this.status }
          })
        })
        if (configs.length > 3 && configs.length % 3 === 0) {
          const _le = configs.length / 3
          for (let index = 0; index < _le; index++) {
            this.borrowList[index] = configs.splice(0, 3)
          }
        } else {
          this.borrowList = configs
        }
        this.swipeList = scrollBars
      }
      this.showSwipeList = true
    },
    // 跳转导流界面
    jumpRiver (e) {
      e.stopPropagation()
      this.$report({
        id: 10269,
        args: {
          screen: this.type, status: 'all', step: this.step
        }
      })
      this.dataPoint(
        {
          id: 10269, screen: this.type, status: 'all', step: this.step
        }
      )// 同步埋点
      this.$router.push({ path: '/river/diversion', query: { source: encodeURIComponent(this.source) } })
    },
    // 去借款
    borrowMoney (item = {}, index) {
      const { directionUrl, configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = item
      this.$sensors.track('Diversion_Click', { product_type: 'diversion', page_status: this.step, element_positon: 'product_list', product_code: configId })
      this.$report({
        id: 10269,
        args: {
          screen: this.type, status: 'borrowMoney', step: this.step, target: configId, type: index
        }
      })
      this.dataPoint(
        {
          id: 10269, screen: this.type, status: 'borrowMoney', step: this.step, target: configId, type: index
        }
      )// 同步埋点
      this.$router.push({ path: '/river/middle', query: { directionUrl: encodeURIComponent(directionUrl), configId, productName, logo, source: encodeURIComponent(this.source), configLimit, needExLogin, autoJump, diversionMode } })
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/mixin.less";

.borrow-list{
  .borrow-tips{
    background-color: #F5F9FF;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: #999999;
    line-height: 30px;
    padding: 9px 0;
    position: relative;
    img{
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
    &::after{
      content: "";
      border-top: 12px solid #F5F9FF;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 12px solid transparent;
      position: absolute;
      bottom: -24px;
      left: 85px;
    }
  }
  .borrow-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
  padding: 0 40px;
    margin-top: 20px;

    .title-left{
      font-size: 34px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      .title-tags{
        display: flex;
        align-items: center;
        margin-left: 10px;
        .tag-item{
          color: #fff;
          font-size: 24px;
          line-height: 35px;
          padding: 0 10px;
          border-radius: 18px;
          &.tag-1{
            background-color: #AFBFD6;
          }
          &.tag-2{
            background-color: #AFD6C7;
            margin-left: 10px;
          }
        }
      }
    }
    .title-right{
      font-size: 28px;
      color: #333330;
      display: flex;
      align-items: center;
      img{
        margin-left: 10px;
        width: 10px;
        height: 17px;
      }
    }
  }
  .borrow-content{
    background-color: #F5F9FF;
    padding: 30px 40px;
    margin-top: 20px;
    .borrow-item{
      background-color: #fff;
      border-radius: 10px;
      border-bottom: 1PX solid #E5EFFE;
      .item-title{
        padding: 20px 30px;

        display: flex;
        align-items: center;
        .title-icon{
          width: 40px;
          height: 40px;
        }
        .title-text{
          font-weight: bold;
          margin-left: 20px;
          font-size: 28px;
          color: #333333;
        }
        .title-tag{
          color: #FF4633;
          border: 1px solid #FF4633;
          font-size: 22px;
          padding: 5px 10px;
          line-height: 1;
          border-radius: 4px;
          margin-left: 10px;
        }
      }
      .item-content{
        position: relative;
        padding: 20px 30px 16px;
        color: #333333;
        .content-text{
          font-size: 24px;
        }
        .content-amount{
          font-size: 40px;
          font-family: DIN-medium, DIN;
          line-height: 48px;
        }
        .content-rate{
          font-size: 24px;
          color: #999999;
          margin-top: 10px;
        }
        .content-btn{
          position: absolute;
          top: 20px;
          right: 30px;
          background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
          border-radius: 30px;
          height: 60px;
          line-height: 60px;
          font-size: 28px;
          color: #FFFFFF;
          min-width: 170px;
          text-align: center;
        }
      }

    }
  }
  .borrow-swipe{
    margin-top: 20px;
    background-color: #F5F9FF;
    text-align: center;
    line-height: 60px;
    height: 60px;
    border-radius: 10px;
    font-size: 22px;
    color: #999999;
  }

  /deep/.van-swipe__indicators {
    display: none;
  }
}
</style>